import { useStorageState } from '@brand/utils';
import { Spacer } from 'components/ui-kit';
import { Column, Container, Row } from 'components/ui-kit/grid';
import { useRef, type JSX } from 'react';
import styles from './quiz-game.module.scss';
import { Answer } from '../../components/answer';
import { Box } from '../../components/box';
import { QUIZ_CURRENT_INDEX_QUESTION_STORAGE_KEY } from '../../quiz.const';
import { TAnswer, questions } from '../../quiz.data';

type TQuizGameProps = {
  onFinish: (score: number) => void;
};
export const QuizGameView = ({ onFinish }: TQuizGameProps): JSX.Element => {
  const [questionIndex, setQuestionIndex] = useStorageState(
    0,
    QUIZ_CURRENT_INDEX_QUESTION_STORAGE_KEY,
    'session',
  );

  const refScore = useRef(0);
  const question = questions[questionIndex];

  const nextQuestion = (): void => {
    if (questions[questionIndex + 1]) {
      return setQuestionIndex((currentIndex: number) => currentIndex + 1);
    }
    return onFinish(refScore.current);
  };

  const onChoose = (answer: TAnswer): void => {
    refScore.current += answer?.weight ?? 0;
    nextQuestion();
  };

  return (
    <Container>
      <Box className={styles.box}>
        <Row>
          <Column span={{ s: 12 }} className={styles.count}>
            {questionIndex + 1}/{questions.length}
          </Column>
          <Column span={{ s: 12 }} className={styles.title}>
            {question.question}
          </Column>
          <Column span={{ s: 12 }}>
            <Spacer size={50} />
            {question.answers.map((answer: TAnswer, index: number) => (
              <Answer
                key={answer.id}
                answer={answer}
                count={index + 1}
                onChoiseAnswer={onChoose}
              />
            ))}
          </Column>
        </Row>
      </Box>
    </Container>
  );
};
